<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ form.name || $t('BUILDING_COMPLEXES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          dark
          color="indigo"
          @click="
            editMode
              ? (editMode = false)
              : $router.push({ name: 'building_complexes' })
          "
        >
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          v-if="!editMode"
          class="ml-2"
          color="primary"
          @click="editMode = true"
          >{{ $t('BUTTON.EDIT') }}</v-btn
        >
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" tile :loading="loading">
      <v-card-text>
        <building-complex-edit
          v-model="form"
          :edit-mode="editMode"
          @cancel="editMode = false"
          @update="
            setData();
            editMode = false;
          "
        />
      </v-card-text>
    </v-card>
    <v-card v-if="form.id" class="mt-3" tile>
      <buildings-apartments-inhabitants-lists :building-complex="form" />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BuildingComplexEdit from '@/modules/building_complexes/components/BuildingComplexEdit';
import { BuildingComplexesService } from '@/services/building-complexes.service';
import BuildingsApartmentsInhabitantsLists from '@/modules/building_complexes/components/BuildingsApartmentsInhabitantsLists';

export default {
  name: 'BuildingComplexShowPage',

  components: {
    BuildingsApartmentsInhabitantsLists,
    BuildingComplexEdit
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: {},
    editMode: false
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  created() {
    this.setData();
  },

  methods: {
    setData() {
      BuildingComplexesService.getById(this.id).then(({ data }) => {
        this.form = data;
      });
    }
  }
};
</script>

<style scoped></style>
